@use '../../../../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../../../../styles/Constants.scss' as Constants;

.MaterialEntryChange {
	display: flex;
	flex-direction: row;
	align-items: center;

	.changeIcon {
		font-size: Constants.$val-icon16;
		font-weight: 700;
		align-self: flex-start;
	}

	.removeIcon {
		font-size: Constants.$val-icon16;
		color: Colors.$col-grey;
		cursor: pointer;
		transition: color 0.1s;
		padding: Constants.$val-spacing-s;
		align-self: center;

		&:hover {
			color: Colors.$col-red;
		}
	}

	&.added {
		.changeIcon {
			color: Colors.$color-green;
		}
	}

	&.removed {
		.changeIcon {
			color: Colors.$color-red;
		}
	}

	.materialEntry {
		flex: 1;
		margin-left: Constants.$val-spacing-s;
	}
}
